import { ChangeDetectorRef, Component, HostListener, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdbTablePaginationComponent, MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { Emplado } from '../empleado';
import { EmpleadoService } from '../empleado.service';
import { Vendedor } from '../vendedor';
import { VendedorService } from '../vendedor.service';

@Component({
  selector: 'app-empleado',
  templateUrl: './empleado.component.html',
  styleUrls: ['./empleado.component.css']
})
export class EmpleadoComponent implements OnInit {

  empleados: Emplado[]= [];
  empladoActuliza: Emplado;
  listaEmpladoActulizar: Emplado[] = [];
  listaPersonActulizar: Emplado[] = [];
  editForm: FormGroup;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  data: Emplado[] = [];
  previous: any = [];
  isLoadingResults = true;

  constructor(private alertService: AlertService,private api: EmpleadoService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder) { }
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }

  grabarEntrada(){
    this.empladoActuliza=new Emplado();
    let datos=this.searchText.split("-");
    this.empladoActuliza.id=0;
    this.empladoActuliza.cedula=datos[0];
    this.empladoActuliza.nombres=datos[1];
    this.listaPersonActulizar[0]=this.empladoActuliza;
    this.api.setActulizarPersona(this.listaPersonActulizar).subscribe(

      data  => {
        this.searchText='';
        this.alertService.success("Se actualizo con exito..");
        this.mdbModal.hide();
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
   

  }

  mensaje(codigo: string) {



    this.api.getVendedor(codigo).subscribe((data: Emplado[]) => {
      console.log(data);
      data.forEach(item => {

        this.editForm.controls.nombres.setValue(item.nombres);
        this.editForm.controls.cedula.setValue(item.cedula);
        this.editForm.controls.estado.setValue(item.estado);
        this.editForm.controls.telefono.setValue(item.telefono);
        this.editForm.controls.id.setValue(item.id);
    
      });





    }, err => {
      console.log(err);
      this.isLoadingResults = false;
    });
    this.mdbModal.show();


  }

  ngOnChanges(changes: SimpleChanges){
    console.log(changes);
}
ngDoCheck(){


}


listarCliente(){

  this.api.getEmpleado(localStorage.getItem('id'))
  .subscribe((
    data: Emplado[]) => {
    this.empleados = data;
    console.log(this.empleados);
    this.mdbTable.setDataSource(this.empleados);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();
  }
    , err => {
      console.log(err);
      this.isLoadingResults = false;
    });
}


  ngOnInit() {
    this.listarCliente();

    this.editForm = this.formBuilder.group({
      nombres: ['', Validators.required],
      cedula: ['', Validators.required],
      telefono: ['', Validators.required],
      estado: ['', Validators.required],
      id: [0, Validators.required]
      
    });


  }
  eliminarCliente(id: number) {
    this.api.eliminarEmpleado(id).subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..");
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      } 
      
      );


  }

  agregarCliente() {
    this.editForm = this.formBuilder.group({
      id: [0, Validators.required],
      nombres: ['', Validators.required],
      telefono: ['', Validators.required],
      cedula: ['', Validators.required],
      estado: ['', Validators.required],
    });

    this.mdbModal.show();
    this.listarCliente();
  }


  actulizarCliente() {
    this.empladoActuliza = new Emplado();
    this.empladoActuliza.nombres = this.editForm.controls.nombres.value;
    this.empladoActuliza.cedula = this.editForm.controls.cedula.value;
    this.empladoActuliza.telefono = this.editForm.controls.telefono.value;
    this.empladoActuliza.estado = this.editForm.controls.estado.value;
    this.empladoActuliza.id = this.editForm.controls.id.value;
    this.empladoActuliza.idEmisor=localStorage.getItem('id');
    this.listaEmpladoActulizar[0] = this.empladoActuliza;

    this.api.setActulizarEmpleado(this.listaEmpladoActulizar).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..");
        this.mdbModal.hide();
        this.listarCliente();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
   


  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(5);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }


  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.empleados = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.empleados = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

}
